"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/lending-eligibility.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Flending-eligibility.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.lendingDenialReasonToJSON = exports.lendingDenialReasonFromJSON = exports.lendingEligibilityCriteriaToJSON = exports.lendingEligibilityCriteriaFromJSON = exports.LendingEligibility = exports.LendingDenialReason = exports.LendingEligibilityCriteria = void 0;
const amount_1 = require("./amount");
const protobufPackage = 'com.step.common.lending.proto';
var LendingEligibilityCriteria;
(function (LendingEligibilityCriteria) {
    LendingEligibilityCriteria["INVALID_CRITERIA"] = "INVALID_CRITERIA";
    LendingEligibilityCriteria["DIRECT_DEPOSIT"] = "DIRECT_DEPOSIT";
    LendingEligibilityCriteria["MONEY_IN"] = "MONEY_IN";
    LendingEligibilityCriteria["STEP_EMPLOYEE"] = "STEP_EMPLOYEE";
    LendingEligibilityCriteria["TEST_LENDING_CRITERIA"] = "TEST_LENDING_CRITERIA";
    LendingEligibilityCriteria["UNRECOGNIZED"] = "UNRECOGNIZED";
})(LendingEligibilityCriteria || (exports.LendingEligibilityCriteria = LendingEligibilityCriteria = {}));
/**
 * Potential reasons why lending may be denied.
 *
 * These reasons may come from a variety of sources. Some are calculated in
 * batch async via ETL/admin-batch and then persisted. Others are calculated
 * in real-time as needed by the server.
 */
var LendingDenialReason;
(function (LendingDenialReason) {
    LendingDenialReason["INVALID_DENIAL_REASON"] = "INVALID_DENIAL_REASON";
    /**
     * HAS_DISPUTES - User has open or previously lost disputes.
     */
    LendingDenialReason["HAS_DISPUTES"] = "HAS_DISPUTES";
    /**
     * FAILED_LOAN_PAYMENT - User has had missed or failed loan repayments from other parties in their
     * transaction history..
     */
    LendingDenialReason["FAILED_LOAN_PAYMENT"] = "FAILED_LOAN_PAYMENT";
    /**
     * INSUFFICIENT_PURCHASE_ACTIVITY - No purchase made in last 30 days
     */
    LendingDenialReason["INSUFFICIENT_PURCHASE_ACTIVITY"] = "INSUFFICIENT_PURCHASE_ACTIVITY";
    /**
     * INSUFFICIENT_DEPOSITS - User has not had enough recent deposits in their account.
     */
    LendingDenialReason["INSUFFICIENT_DEPOSITS"] = "INSUFFICIENT_DEPOSITS";
    /**
     * INSUFFICIENT_DIRECT_DEPOSITS - User has not had enough recent direct deposits in their account.
     */
    LendingDenialReason["INSUFFICIENT_DIRECT_DEPOSITS"] = "INSUFFICIENT_DIRECT_DEPOSITS";
    /**
     * NOT_KYCED - User is not KYCed.
     */
    LendingDenialReason["NOT_KYCED"] = "NOT_KYCED";
    /**
     * INACTIVE_ACCOUNT - The user's account is suspended or closed.
     */
    LendingDenialReason["INACTIVE_ACCOUNT"] = "INACTIVE_ACCOUNT";
    /**
     * HIGH_RISK_SCORE - The user's risk score is above threshold value.
     */
    LendingDenialReason["HIGH_RISK_SCORE"] = "HIGH_RISK_SCORE";
    /**
     * FAILED_POT_LOAN_REPAYMENTS - The user has been past due on a PoT loan.
     */
    LendingDenialReason["FAILED_POT_LOAN_REPAYMENTS"] = "FAILED_POT_LOAN_REPAYMENTS";
    /**
     * INSUFFICIENT_HISTORY - Insufficient information pulled from credit bureaus.
     */
    LendingDenialReason["INSUFFICIENT_HISTORY"] = "INSUFFICIENT_HISTORY";
    /**
     * DELINQUENCIES - Late payments or delinquencies identified on credit report.
     */
    LendingDenialReason["DELINQUENCIES"] = "DELINQUENCIES";
    /**
     * HIGH_UTILIZATION - High utilization of credit lines
     */
    LendingDenialReason["HIGH_UTILIZATION"] = "HIGH_UTILIZATION";
    /**
     * CREDIT_SCORE - Credit score
     */
    LendingDenialReason["CREDIT_SCORE"] = "CREDIT_SCORE";
    /**
     * OPEN_ACCOUNTS - Open trade lines of credit
     */
    LendingDenialReason["OPEN_ACCOUNTS"] = "OPEN_ACCOUNTS";
    /**
     * INQUIRIES - Recent credit inquiries
     */
    LendingDenialReason["INQUIRIES"] = "INQUIRIES";
    /**
     * STEP_FUNDING_ALL - Step data - funding related activities, all time
     */
    LendingDenialReason["STEP_FUNDING_ALL"] = "STEP_FUNDING_ALL";
    /**
     * STEP_PURCHASE_RECENT - Step data - purchase related activities, recent
     */
    LendingDenialReason["STEP_PURCHASE_RECENT"] = "STEP_PURCHASE_RECENT";
    /**
     * UNSUPPORTED_REGION - The user region is not supported
     */
    LendingDenialReason["UNSUPPORTED_REGION"] = "UNSUPPORTED_REGION";
    /**
     * FRAUD_ALERT_UNABLE_TO_VERIFY_IDENTITY - User's credit report contains fraud alerts
     */
    LendingDenialReason["FRAUD_ALERT_UNABLE_TO_VERIFY_IDENTITY"] = "FRAUD_ALERT_UNABLE_TO_VERIFY_IDENTITY";
    LendingDenialReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(LendingDenialReason || (exports.LendingDenialReason = LendingDenialReason = {}));
function createBaseLendingEligibility() {
    return {
        eligibleAmount: amount_1.Amount.fromPartial({}),
        qualified: false,
        apr: 0,
        denialReasons: [],
        metCriteria: [],
        missingCriteria: [],
    };
}
exports.LendingEligibility = {
    fromJSON(object) {
        const message = {
            eligibleAmount: isSet(object.eligibleAmount)
                ? amount_1.Amount.fromJSON(object.eligibleAmount)
                : amount_1.Amount.fromPartial({}),
            qualified: isSet(object.qualified) ? globalThis.Boolean(object.qualified) : false,
            denialReasons: globalThis.Array.isArray(object?.denialReasons)
                ? object.denialReasons.map((e) => lendingDenialReasonFromJSON(e))
                : [],
            metCriteria: globalThis.Array.isArray(object?.metCriteria)
                ? object.metCriteria.map((e) => lendingEligibilityCriteriaFromJSON(e))
                : [],
            missingCriteria: globalThis.Array.isArray(object?.missingCriteria)
                ? object.missingCriteria.map((e) => lendingEligibilityCriteriaFromJSON(e))
                : [],
        };
        if (isSet(object.apr)) {
            message.apr = globalThis.Number(object.apr);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.eligibleAmount !== undefined) {
            obj.eligibleAmount = amount_1.Amount.toJSON(message.eligibleAmount);
        }
        if (message.qualified !== false) {
            obj.qualified = message.qualified;
        }
        if (message.apr !== undefined && message.apr !== 0) {
            obj.apr = message.apr;
        }
        if (message.denialReasons?.length) {
            obj.denialReasons = message.denialReasons.map((e) => lendingDenialReasonToJSON(e));
        }
        if (message.metCriteria?.length) {
            obj.metCriteria = message.metCriteria.map((e) => lendingEligibilityCriteriaToJSON(e));
        }
        if (message.missingCriteria?.length) {
            obj.missingCriteria = message.missingCriteria.map((e) => lendingEligibilityCriteriaToJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.LendingEligibility.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLendingEligibility();
        message.eligibleAmount = (object.eligibleAmount !== undefined && object.eligibleAmount !== null)
            ? amount_1.Amount.fromPartial(object.eligibleAmount)
            : amount_1.Amount.fromPartial({});
        message.qualified = object.qualified ?? false;
        message.apr = object.apr ?? 0;
        message.denialReasons = object.denialReasons?.map((e) => e) || [];
        message.metCriteria = object.metCriteria?.map((e) => e) || [];
        message.missingCriteria = object.missingCriteria?.map((e) => e) || [];
        return message;
    },
};
function lendingEligibilityCriteriaFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CRITERIA':
            return LendingEligibilityCriteria.INVALID_CRITERIA;
        case 1:
        case 'DIRECT_DEPOSIT':
            return LendingEligibilityCriteria.DIRECT_DEPOSIT;
        case 2:
        case 'MONEY_IN':
            return LendingEligibilityCriteria.MONEY_IN;
        case 3:
        case 'STEP_EMPLOYEE':
            return LendingEligibilityCriteria.STEP_EMPLOYEE;
        case 1000:
        case 'TEST_LENDING_CRITERIA':
            return LendingEligibilityCriteria.TEST_LENDING_CRITERIA;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return LendingEligibilityCriteria.UNRECOGNIZED;
    }
}
exports.lendingEligibilityCriteriaFromJSON = lendingEligibilityCriteriaFromJSON;
function lendingEligibilityCriteriaToJSON(object) {
    switch (object) {
        case LendingEligibilityCriteria.INVALID_CRITERIA:
            return 'INVALID_CRITERIA';
        case LendingEligibilityCriteria.DIRECT_DEPOSIT:
            return 'DIRECT_DEPOSIT';
        case LendingEligibilityCriteria.MONEY_IN:
            return 'MONEY_IN';
        case LendingEligibilityCriteria.STEP_EMPLOYEE:
            return 'STEP_EMPLOYEE';
        case LendingEligibilityCriteria.TEST_LENDING_CRITERIA:
            return 'TEST_LENDING_CRITERIA';
        case LendingEligibilityCriteria.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.lendingEligibilityCriteriaToJSON = lendingEligibilityCriteriaToJSON;
function lendingDenialReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DENIAL_REASON':
            return LendingDenialReason.INVALID_DENIAL_REASON;
        case 2:
        case 'HAS_DISPUTES':
            return LendingDenialReason.HAS_DISPUTES;
        case 3:
        case 'FAILED_LOAN_PAYMENT':
            return LendingDenialReason.FAILED_LOAN_PAYMENT;
        case 4:
        case 'INSUFFICIENT_PURCHASE_ACTIVITY':
            return LendingDenialReason.INSUFFICIENT_PURCHASE_ACTIVITY;
        case 8:
        case 'INSUFFICIENT_DEPOSITS':
            return LendingDenialReason.INSUFFICIENT_DEPOSITS;
        case 1:
        case 'INSUFFICIENT_DIRECT_DEPOSITS':
            return LendingDenialReason.INSUFFICIENT_DIRECT_DEPOSITS;
        case 5:
        case 'NOT_KYCED':
            return LendingDenialReason.NOT_KYCED;
        case 6:
        case 'INACTIVE_ACCOUNT':
            return LendingDenialReason.INACTIVE_ACCOUNT;
        case 7:
        case 'HIGH_RISK_SCORE':
            return LendingDenialReason.HIGH_RISK_SCORE;
        case 9:
        case 'FAILED_POT_LOAN_REPAYMENTS':
            return LendingDenialReason.FAILED_POT_LOAN_REPAYMENTS;
        case 10:
        case 'INSUFFICIENT_HISTORY':
            return LendingDenialReason.INSUFFICIENT_HISTORY;
        case 11:
        case 'DELINQUENCIES':
            return LendingDenialReason.DELINQUENCIES;
        case 12:
        case 'HIGH_UTILIZATION':
            return LendingDenialReason.HIGH_UTILIZATION;
        case 13:
        case 'CREDIT_SCORE':
            return LendingDenialReason.CREDIT_SCORE;
        case 14:
        case 'OPEN_ACCOUNTS':
            return LendingDenialReason.OPEN_ACCOUNTS;
        case 15:
        case 'INQUIRIES':
            return LendingDenialReason.INQUIRIES;
        case 16:
        case 'STEP_FUNDING_ALL':
            return LendingDenialReason.STEP_FUNDING_ALL;
        case 17:
        case 'STEP_PURCHASE_RECENT':
            return LendingDenialReason.STEP_PURCHASE_RECENT;
        case 18:
        case 'UNSUPPORTED_REGION':
            return LendingDenialReason.UNSUPPORTED_REGION;
        case 19:
        case 'FRAUD_ALERT_UNABLE_TO_VERIFY_IDENTITY':
            return LendingDenialReason.FRAUD_ALERT_UNABLE_TO_VERIFY_IDENTITY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return LendingDenialReason.UNRECOGNIZED;
    }
}
exports.lendingDenialReasonFromJSON = lendingDenialReasonFromJSON;
function lendingDenialReasonToJSON(object) {
    switch (object) {
        case LendingDenialReason.INVALID_DENIAL_REASON:
            return 'INVALID_DENIAL_REASON';
        case LendingDenialReason.HAS_DISPUTES:
            return 'HAS_DISPUTES';
        case LendingDenialReason.FAILED_LOAN_PAYMENT:
            return 'FAILED_LOAN_PAYMENT';
        case LendingDenialReason.INSUFFICIENT_PURCHASE_ACTIVITY:
            return 'INSUFFICIENT_PURCHASE_ACTIVITY';
        case LendingDenialReason.INSUFFICIENT_DEPOSITS:
            return 'INSUFFICIENT_DEPOSITS';
        case LendingDenialReason.INSUFFICIENT_DIRECT_DEPOSITS:
            return 'INSUFFICIENT_DIRECT_DEPOSITS';
        case LendingDenialReason.NOT_KYCED:
            return 'NOT_KYCED';
        case LendingDenialReason.INACTIVE_ACCOUNT:
            return 'INACTIVE_ACCOUNT';
        case LendingDenialReason.HIGH_RISK_SCORE:
            return 'HIGH_RISK_SCORE';
        case LendingDenialReason.FAILED_POT_LOAN_REPAYMENTS:
            return 'FAILED_POT_LOAN_REPAYMENTS';
        case LendingDenialReason.INSUFFICIENT_HISTORY:
            return 'INSUFFICIENT_HISTORY';
        case LendingDenialReason.DELINQUENCIES:
            return 'DELINQUENCIES';
        case LendingDenialReason.HIGH_UTILIZATION:
            return 'HIGH_UTILIZATION';
        case LendingDenialReason.CREDIT_SCORE:
            return 'CREDIT_SCORE';
        case LendingDenialReason.OPEN_ACCOUNTS:
            return 'OPEN_ACCOUNTS';
        case LendingDenialReason.INQUIRIES:
            return 'INQUIRIES';
        case LendingDenialReason.STEP_FUNDING_ALL:
            return 'STEP_FUNDING_ALL';
        case LendingDenialReason.STEP_PURCHASE_RECENT:
            return 'STEP_PURCHASE_RECENT';
        case LendingDenialReason.UNSUPPORTED_REGION:
            return 'UNSUPPORTED_REGION';
        case LendingDenialReason.FRAUD_ALERT_UNABLE_TO_VERIFY_IDENTITY:
            return 'FRAUD_ALERT_UNABLE_TO_VERIFY_IDENTITY';
        case LendingDenialReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.lendingDenialReasonToJSON = lendingDenialReasonToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=lending-eligibility.js.map